import React from 'react';
import * as Yup from 'yup';
import { AccountCreationForm } from '../AccountCreationForm';
import CredentialsFields from './CredentialsFields';

//password needs at least 8 characters, a number, a mix of lowercase and uppercase letters, and no spaces
//email needs to be in the format of an email address .*@.*\..* and is required

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .required('Email is required')
    .matches(/.*@.*\..*/, 'Email must be a valid email address'),
  password: Yup.string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^\s]*$/,
      'Password must contain at least one uppercase letter, one lowercase letter, and one number, and no spaces'
    ),
});

const initialValues = {
  email: '',
  password: '',
};

interface Props {
  accountCreationWrapperStyles?: String[];
}

export const CredentialsForm: React.FC<Props> = ({ accountCreationWrapperStyles }) => {
  return (
    <div className={accountCreationWrapperStyles?.join(',')}>
      <AccountCreationForm
        initialValues={initialValues}
        validationSchema={validationSchema}
        Component={CredentialsFields}
        shouldSignup={true}
      />
    </div>
  );
};
